import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { UserPlus, Check, X, Users } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3";

export default function Requests() {
  const [requests, setRequests] = useState([]);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => {
    Promise.all([api.get("/friends/requests"), api.get("/friends")])
      .then(([r, f]) => { setRequests(r.data); setFriends(f.data); })
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const respond = async (request_id, accept) => {
    await api.post("/friends/respond", { request_id, accept });
    toast.success(accept ? "Friend request accepted" : "Request declined");
    load();
  };

  return (
    <div className="p-6 md:p-12 max-w-3xl mx-auto">
      <div className="overline mb-1">Your circle</div>
      <h2 className="font-heading text-3xl md:text-4xl mb-8">Friend Requests</h2>

      {loading ? <div className="text-[#A0A0A0]">Loading…</div> : (
        <>
          <div className="mb-10">
            <div className="flex items-center gap-2 text-sm text-[#A0A0A0] mb-3"><UserPlus size={16} className="text-[#D4AF37]" /> Incoming ({requests.length})</div>
            {requests.length === 0 ? (
              <div className="pe-card rounded-2xl p-6 text-sm text-[#A0A0A0]">No pending requests.</div>
            ) : (
              <div className="space-y-3">
                {requests.map((r) => (
                  <motion.div key={r.request_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                    data-testid={`request-${r.request_id}`} className="pe-card rounded-2xl p-4 flex items-center gap-4">
                    <img src={r.user.photos?.[0] || FALLBACK} alt="" className="w-14 h-14 rounded-full object-cover border border-[#D4AF37]/40" />
                    <div className="flex-1 min-w-0">
                      <div className="font-heading text-xl">{r.user.name}</div>
                      <div className="text-xs text-[#A0A0A0]">{r.user.location}</div>
                    </div>
                    <button data-testid={`accept-${r.request_id}`} onClick={() => respond(r.request_id, true)}
                      className="w-11 h-11 rounded-full gold-gradient text-black flex items-center justify-center"><Check size={18} /></button>
                    <button data-testid={`reject-${r.request_id}`} onClick={() => respond(r.request_id, false)}
                      className="w-11 h-11 rounded-full border border-[#E63946] text-[#E63946] flex items-center justify-center"><X size={18} /></button>
                  </motion.div>
                ))}
              </div>
            )}
          </div>

          <div>
            <div className="flex items-center gap-2 text-sm text-[#A0A0A0] mb-3"><Users size={16} className="text-[#D4AF37]" /> Friends ({friends.length})</div>
            {friends.length === 0 ? (
              <div className="pe-card rounded-2xl p-6 text-sm text-[#A0A0A0]">No friends yet.</div>
            ) : (
              <div className="grid sm:grid-cols-2 gap-3">
                {friends.map((f) => (
                  <div key={f.id} data-testid={`friend-${f.id}`} onClick={() => navigate(`/creator/${f.id}`)}
                    className="pe-card rounded-2xl p-4 flex items-center gap-3 cursor-pointer">
                    <img src={f.photos?.[0] || FALLBACK} alt="" className="w-12 h-12 rounded-full object-cover border border-[#D4AF37]/40" />
                    <div className="font-heading text-lg">{f.name}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
